import { useEffect, useState } from "react";
import BasicDatatable from "../Common/BasicDatatable";
import { getColumns } from "../Contacts/contactsTableConfig";
import CommonService from "../../services/common/commonService";
import { Box } from "@mui/material";
import SlideOver from "../Common/SlideOver";
import ContactsProfile from "./ContactsProfile";
import ContactsInteractionView from "./ContactsInteractionView";
import useDisplaySnackbar from "../../utils/useDisplaySnackbar";
import { useLocation } from "react-router-dom";
import KaratContactsTable from "../Karat Data";

interface ContactsProps {
  slideOverParent?: string;
}

const generateRows = (contacts: any[], onNameClick: any) =>
  contacts.map((item: any) => ({
    profileOrgId: item.profileOrgRelationshipId,
    firstName: item.firstName,
    lastName: item.lastName,
    email:  item.empEmail,
    accounts:  item.orgName,
    isActive: item.isActive,
    onNameClick: () => onNameClick(item),
  }));

const Contacts = ({
  slideOverParent = "contacts-slideOver",
}: ContactsProps) => {
  const location = useLocation();
  const [columns] = useState<any[]>(getColumns());
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(50);
  const [rows, setRows] = useState<any[]>([]);
  const [rowCount, setRowCount] = useState<number>(0);
  const [ slideOverOpen, setSlideOverOpen] = useState<boolean>(false);
  const [ userEmail, setUserEmail] = useState("");
  // const slideOverParent = "contacts-slideOver";
  const parentPageIdentifier = "contacts";
  const [showSpinner, setShowSpinner] = useState(false);
  const { showSnackbar } = useDisplaySnackbar();
  const incomingSlideOverParent = location.state?.slideOverParent;
  const isClientInteraction = true;
  const [ profileOrgId, setProfileOrgId] = useState(location.state?.profileOrgId);
  const incomingEmail = location.state?.userEmail;
  const removeCustomDateRange = false;

  const KaratData = [
    {profileOrgId: "87e3cc14-c3ca-4d37-85d5-eb3f86ee3788",firstName: "Nathan",lastName: "Rader",email:  "nathan.rader@karat.com",accounts:  "karat.com",isActive: "true", designation: "Chief Revenue Officer", sentiment: "Positive"},
    {profileOrgId: "3867597c-dfe2-4287-a41f-bc0eab95670b",firstName: "Em",lastName: "Draime",email:  "edraime@karat.com",accounts:  "karat.com",isActive: "true", designation:"Director, Revenue Ops", sentiment: "Negative"},
    {profileOrgId: "16903464-dca5-4ee0-a6ca-290835e89969",firstName: "Mridul",lastName: "Juyal",email: "mridul.juyal@karat.com",accounts: "karat.com",isActive: "true", designation:"Deployment Engineer", sentiment: "Neutral"},
  ]

  useEffect(() => {
    if (incomingSlideOverParent === slideOverParent) {
      setUserEmail(incomingEmail);
      setProfileOrgId(profileOrgId);
      setSlideOverOpen(true);
    }
  }, [incomingSlideOverParent]);
  const { 
    isLoading, 
    isFetching,
    isSuccess,
    isError,
    error,
    data 
  } = CommonService.useGetContacts(
    { offset: pageNumber, limit: pageSize },
    true
  );

  useEffect(() => {
    setShowSpinner(isLoading || isFetching);
    if (!data ) return;
    if(isSuccess && data){
      let rawItems: any[] = Array.isArray(data.data) ? data.data : [];
      if (slideOverParent === "account-parent-page") {
        // Use KaratData for account-parent-page
        rawItems = KaratData;
      }
      const mapped = generateRows(rawItems, onNameClick);
      setRows(mapped);
      setRowCount(data.totalRecords ?? mapped.length);
    }
    else if(isError){
      showSnackbar("error", error?.message || "Failed to load data.");
    }
  }, [data, isLoading, isFetching, isSuccess, isError, error]);

  const handlePageChange = (newPage: number) => {
    setPageNumber(newPage+1);
  };

  const handlePageSizeChange = (newPageSize: number) => {
    setPageSize(newPageSize);
    setPageNumber(1);
  };

  const onNameClick = (item: any) => {
    setUserEmail(item.empEmail);
    setSlideOverOpen(true);
    setProfileOrgId(item.profileOrgRelationshipId); 
  };

  return (
    <>
    {
    slideOverParent === "account-parent-page" ? (
      <KaratContactsTable
        data={KaratData}
        onNameClick={(contact) => {
          setUserEmail(contact.email);
          setProfileOrgId(contact.profileOrgId);
          setSlideOverOpen(true);
        }}
      />
    ) : (
    <Box sx={{overflowY: "hidden"}}>
      <BasicDatatable
        columns={columns}
        rows={rows}
        rowCount={rowCount}
        onPageSizeChange={handlePageSizeChange}
        onPaginationChange={handlePageChange}
        minHeight="calc(100vh - 180px)"
        showSpinner = {showSpinner}
        isBordervisible={slideOverParent === "account-parent-page"}
      />
    </Box>
    )}
    <SlideOver isOpen={slideOverOpen} onClose={() => setSlideOverOpen(false)}>
      <ContactsProfile 
        email={userEmail}
        profileOrgId={profileOrgId}
        isSlideOverOpen={slideOverOpen}
      />
      <ContactsInteractionView
        userEmail={userEmail}
        isSlideOverOpen={slideOverOpen}
        slideOverParent={slideOverParent}
        parentPageIdentifier={parentPageIdentifier}
        isClientInteraction={isClientInteraction}
        removeCustomDateRange={removeCustomDateRange}
        profileOrgId={profileOrgId}
      />
    </SlideOver>
    </>
  );
};

export default Contacts;